<div style="background-color:white;width:28%;margin-left:73%;margin-top:-3%;" align="right">
    <iframe id="chatbotFrame" [src]="chatUrl" style="height:85vh;width:100%"></iframe>
</div>
<script>

    var xhr = new XMLHttpRequest();
    xhr.open('GET', "https://webchat.botframework.com/api/tokens", true);
    xhr.setRequestHeader('Authorization', 'BotConnector ' + 'ZUOE8qyfTuw.cwA.7tc.LC4tRKMmx0RmDIF3u3jO_K5BAOQYLA9WkNNlYcZzUpI');
    xhr.send();
    xhr.onreadystatechange = processRequest;

    function processRequest(e) {
      if (xhr.readyState == 4  && xhr.status == 200) {
        var response = JSON.parse(xhr.responseText);
        document.getElementById("chat").src="https://webchat.botframework.com/embed/lucas-direct-line?t="+response
      }
    }

    $(document).ready(function () {

        $('.wc-message-groups').css('background-color','white')
    })
</script>
